import { reputations, siteMeta } from "@/mocks/news";

const principles = [
  {
    icon: "ri-shield-check-line",
    title: "只写能核对的细节",
    text: "没有时间、没有来源、只有情绪的内容不会被收录，宁可晚一点发。",
  },
  {
    icon: "ri-history-line",
    title: "反转写回原条目",
    text: "补充与澄清都留在同一条时间线上，不另起一条把旧结论藏起来。",
  },
  {
    icon: "ri-scales-3-line",
    title: "标注状态而不是下结论",
    text: "待确认、等待回应、持续跟进，三种状态如实呈现，判断留给你。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-accent-700">
              <i className="ri-information-line" aria-hidden />
              关于我们
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              {siteMeta.name}：把瓜整理清楚的那一个
            </h2>

            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              {siteMeta.description}
              我们不生产情绪，只负责把同一件事在不同时间点出现的说法排好顺序，让你先看前情、再看反转。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              网站定位很明确：面向想快人一步、又不想被旧截图误导的读者。与其在各个群里来回求证，
              不如在一个页面上把线索、状态和后续一次看全。
            </p>

            <h3 className="mt-8 font-heading text-base font-bold text-foreground-900">内容原则</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {principles.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-lg`} aria-hidden />
                  </span>
                  <h4 className="mt-3 font-heading text-sm font-bold text-foreground-950">
                    {item.title}
                  </h4>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-contacts-line text-primary-600" aria-hidden />
                联系方式
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                有线索、有补充，或者发现我们写错了地方，都可以直接写邮件。带上时间和描述，
                我们会更快处理。
              </p>
              <dl className="mt-5 flex flex-col gap-3 text-sm">
                <div className="flex items-center gap-3 rounded-md bg-background-100 px-4 py-3">
                  <i className="ri-mail-line text-lg text-accent-700" aria-hidden />
                  <dt className="sr-only">联系邮箱</dt>
                  <dd className="text-foreground-900">{siteMeta.email}</dd>
                </div>
                <div className="flex items-center gap-3 rounded-md bg-background-100 px-4 py-3">
                  <i className="ri-time-line text-lg text-accent-700" aria-hidden />
                  <dt className="sr-only">处理时间</dt>
                  <dd className="text-foreground-900">{siteMeta.contactTime}</dd>
                </div>
              </dl>
              <a
                href="#subscribe"
                className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-notification-3-line" aria-hidden />
                订阅首发推送
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
            <i className="ri-chat-quote-line text-secondary-700" aria-hidden />
            读者怎么说
          </h3>
          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
            {reputations.map((item) => (
              <blockquote
                key={item.name}
                className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-secondary-500" aria-hidden />
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.text}</p>
                <footer className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-background-50">
                    {item.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}